import { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaTelegramPlane,
  FaTwitter,
  // FaSnapchatGhost,
  // FaMailBulk,
  // FaPhoneSlash,
  FaInstagram,
} from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { LuMailPlus } from "react-icons/lu";

import { UserContext } from "../context/UserContext";

export default function FooterSection() {
  const { user } = useContext(UserContext);
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="footer-section">
      {/* <div className="footer_container">
        <div className="footer_nav_links">
          <h3>Navigations</h3>
          <NavLink to={"/home"} className={"footer_link"}>
            Home
          </NavLink>
          <NavLink to={"/about"} className={"footer_link"}>
            About
          </NavLink>
          <NavLink to={"/plan"} className={"footer_link"}>
            Plans
          </NavLink>
          <NavLink to={"/contact"} className={"footer_link"}>
            Contact
          </NavLink>
          <NavLink to={"/login"} className={"footer_link"}>
            Login
          </NavLink>
          <NavLink to={"/signup"} className={"footer_link"}>
            Sign up
          </NavLink>
        </div>

        <div className="important_links">
          <h3>Important links</h3>
          <NavLink to={"/plans"} className={"footer_link"}>
            Pricing plan
          </NavLink>
          <NavLink to={"/predictions/freebet"} className={"footer_link"}>
            Bet of the day
          </NavLink>
          <NavLink to={"/predictions/freebet"} className={"footer_link"}>
            Today free Bet
          </NavLink>
          <NavLink to={"/faqs"} className={"footer_link"}>
            FAQ
          </NavLink>
          <NavLink to={"/terms"} className={"footer_link"}>
            Terms and conditions
          </NavLink>
        </div>

        <div className="contact_links">
          <h3>Contact Us</h3>
          <NavLink to={"tel:233500200513"} className={"footer_link"}>
            233 500 20 0513
          </NavLink>
          <NavLink
            to={"mailto:asakaafixed@gmail.com"}
            className={"footer_link"}
          >
           asakaafixed@gmail.com
          </NavLink>

          <div className="social_links">
            <NavLink to={"https://x.com/asakaafixed?s=21"} className={"social_link"}>
              <FaFacebookF />
            </NavLink>

            <NavLink to={"https://t.me/FREEASAKAA"} className={"social_link"}>
              <FaTelegramPlane />
            </NavLink>

            <NavLink to={"https://x.com/asakaafixed?s=21"} className={"social_link"}>
              <FaTwitter />
            </NavLink>

            <NavLink to={"https://www.instagram.com/yambata1?igsh=MXFiZ2dnaDl0MmR4bg%3D%3D&utm_source=qr"} className={"social_link"}>
              <FaInstagram />
            </NavLink>
          </div>
        </div>
      </div>
      <hr /> */}

      <div className="footer_container">
        <div className="footer_socials">
          <div className="social_links">
            <NavLink
              to={"https://x.com/asakaafixed?s=21"}
              className={"social_link"}
            >
              <FaFacebookF />
            </NavLink>

            <NavLink to={"https://t.me/asakaafixed01"} className={"social_link"}>
              <FaTelegramPlane />
            </NavLink>

            <NavLink
              to={"https://x.com/asakaafixed?s=21"}
              className={"social_link"}
            >
              <FaTwitter />
            </NavLink>

            <NavLink
              to={
                "https://www.instagram.com/yambata1?igsh=MXFiZ2dnaDl0MmR4bg%3D%3D&utm_source=qr"
              }
              className={"social_link"}
            >
              <FaInstagram />
            </NavLink>
          </div>

          <div className="footer_contacts">
            <div className="footer_contact">
              <LuMailPlus size={30} className="contact_icon" />
              <div>
                <span
                  style={{
                    color: "#cfcfcfff",
                  }}
                >
                  Email Us
                </span>
                <span
                  style={{
                    color: "#b5b5b5ff",
                  }}
                >
                  asakaafixed@gmail.com
                </span>
              </div>
            </div>
            <div className="footer_contact">
              <FiPhoneCall size={30} className="contact_icon" />
              <div>
                <span
                  style={{
                    color: "#cfcfcfff",
                  }}
                >
                  Get In Touch
                </span>
                <span
                  style={{
                    color: "#b5b5b5ff",
                  }}
                >
                  233 500 20 0513
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        <div
          onClick={() =>
            user && user.email === "asakaagame@gmail.com"
              ? navigate("/users")
              : null
          }
          className="payment_methods"
        >
          <img
            src="/payment_method_images/mtn.jpg"
            alt="mtn momo"
            className="p_method"
          />
          <img
            src="/payment_method_images/telecel.jpg"
            alt="telecel cash"
            className="p_method"
          />
          <img
            src="/payment_method_images/visa.jpg"
            alt="visa"
            className="p_method"
          />
          <img
            src="/payment_method_images/mastercard.jpg"
            alt="mastercard"
            className="p_method"
          />
          <img
            src="/payment_method_images/btc.jpg"
            alt="mtn momo"
            className="p_method"
          />
        </div>
      }

      {/* <hr /> */}

      {user && user.email === "asakaagame@gmail.com" ? (
        <a href={"/addBet"}>
          <p>Asakaa Play @ {year}. All right reserved.</p>
        </a>
      ) : (
        <p>Asakaa Play @ {year}. All right reserved.</p>
      )}
    </footer>
  );
}
